import { t } from 'i18next'
import { Chip } from 'primereact/chip'
import { MultiSelect } from 'primereact/multiselect'
import { Controller, useFormContext } from 'react-hook-form'
import { Group } from '../../../../../model/group.model'
import { useAppSelector } from '../../../../../redux/hooks'

export const GroupMultiselect = () => {
  const groups = useAppSelector((state) => state.groups)

  const formMethods = useFormContext()

  const optionItem = (option: Group) => {
    if (option)
      return (
        <div key={option.group_id}>
          <span>{option.group_name}</span>
          <span className={'ml-2 small-text secondary-text'}>
            {option.group_description}
          </span>
        </div>
      )
  }

  const removeItem = (group: Group) => {
    const selectedGroups = formMethods.getValues('groups')
    const filteredGroup = selectedGroups.filter(
      (g: Group) => g.group_id !== group.group_id
    )
    formMethods.setValue('groups', filteredGroup ? filteredGroup : [], {
      shouldDirty: true,
    })
  }

  const selectedItem = (option: Group) => {
    if (option) {
      return (
        <Chip
          removable={true}
          onRemove={() => removeItem(option)}
          className={'mx-1 '}
          label={option.group_name}
        />
      )
    }
  }

  return (
    <Controller
      name={'groups'}
      control={formMethods.control}
      rules={{ required: true }}
      render={({ field }) => (
        <MultiSelect
          options={groups}
          dataKey={'group_id'}
          {...field}
          optionLabel={'group_name'}
          itemTemplate={optionItem}
          selectedItemTemplate={selectedItem}
          filter
          className={'col'}
          placeholder={t<string>('core.select')}
        />
      )}
    />
  )
}